import { Utility } from 'src/app/shared/utility';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NewUserFormData, UserEmails } from 'src/app/models/form-field';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { UserOrgs } from 'src/app/models/organization';

@Component({
  selector: 'app-add-edit-users',
  templateUrl: './add-edit-users.component.html',
  styleUrls: ['./add-edit-users.component.css']
})
export class AddEditUsersComponent implements OnInit {
  isEditRecord: boolean;
  isAddRecord: boolean;
  isAddUserOpened: boolean;
  confirmEmail: boolean;
  userFormData: NewUserFormData;
  subFormData: NewUserFormData;
  userEmailData: UserEmails;
  public userRoles: any[];
  invalidPatternMatch: boolean;
  existingRecords: boolean;
  newRecord: boolean;
  currentSection = 1;
  userRecord: any;
  usersByIdData: boolean;
  isConfirmOpened: boolean;
  currentRecordId = 0;
  activeUserMsg: any;
  lockedAccount: any;
  rolesValidationMsg: any;
  invalidEmailFormatMsg: any;
  invalidPatternMatchMsg: any;
  emailEntriesValid: boolean;
  isProcessing = false;
  invalidEmailFormat = false;
  @Input() public userData: any[];

  @Input()
  set userInfo(userInfo: any) {
    this.addEditInfo(userInfo);
  }

  @Output() responseMsg: EventEmitter<any> = new EventEmitter();

  constructor(private usersService: UsersService,
              private readConfigService: ReadConfigService,
              private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.getRoles();
    const config = this.readConfigService.getUserManagement();
    this.activeUserMsg = config.ActiveUserMessage;
    this.lockedAccount = config.LockedAccount;
    this.rolesValidationMsg = config.RolesValidationMsg;
    this.invalidPatternMatchMsg = config.InvalidPatternMatch;
    this.invalidEmailFormatMsg = config.InvalidEmailFormat;
  }

  disableNext(addUserEmailForm: any) {
    return !(addUserEmailForm.valid && addUserEmailForm.dirty)
    || this.invalidEmailFormat || this.invalidPatternMatch || this.disableLogic();
  }

  getUserDetailsById(id: any) {
    this.usersService.getUserById(id).subscribe(response => {
      if (response && response.result) {
        const data = response.result;
        this.userFormData = this.getUpdatedData(data);
        this.userEmailData.NewEmailAddress = this.userFormData.emailAddress;
        this.userEmailData.ConfirmEmailAddress = this.userFormData.emailAddress;
        this.isAddUserOpened = true;
      } else {
        this.notificationService.setErrorNotification();
      }
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.notificationService.setErrorNotification();
    });
  }

  disableLogic() {
    const euser = this.userEmailData.ExistingUser;
    if (euser === false) {
      return false;
    } else if (euser && this.userEmailData.CreateUser.length > 0) {
      return false;
    }
    return true;
  }

  addEditInfo(userInfo) {
    this.userRecord = {};
    this.isAddUserOpened = false;
    if (userInfo) {
      this.invalidPatternMatch = false;
      this.invalidEmailFormat = false;
      this.newRecord = false;
      this.currentSection = 1;
      this.userFormData = new NewUserFormData();
      this.userEmailData = new UserEmails();
      this.userFormData.activeOrgUser = false;
      this.userEmailData.ExistingUser = false;
      this.isAddRecord = (userInfo.action === 'add');
      this.isEditRecord = !this.isAddRecord;
      if (this.isEditRecord) {
        this.userEmailData.ExistingUser = true;
        this.currentSection = 2;
        this.getUserDetailsById(userInfo.dataItem.id);
      } else {
        this.existingRecords = false;
        this.isAddUserOpened = true;
      }
    }
  }

  getRoles() {
    this.usersService.getRolesList()
      .subscribe(response => {
        if (response && response.success) {
          this.userRoles = response.data;
        } else {
          this.notificationService.setErrorNotification();
        }
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setErrorNotification();
      });
  }

  onChange() {
    this.userRecord = new NewUserFormData();
    const email = Utility.lowerString(this.userEmailData.NewEmailAddress);
    this.userEmailData.NewEmailAddress = email;
    this.userEmailData.ConfirmEmailAddress = Utility.lowerString(this.userEmailData.ConfirmEmailAddress);
    this.currentRecordId = 0;
    this.userEmailData.CreateUser = '';
    this.existingRecords = false;
    this.userEmailData.ExistingUser = true;
    const patternMatched = Utility.isValidEmail(email);
    this.emailEntriesValid = email === this.userEmailData.ConfirmEmailAddress;
    if (this.emailEntriesValid && patternMatched) {
      this.invalidPatternMatch = false;
      this.invalidEmailFormat = false;
      const emailAddress = this.userEmailData.NewEmailAddress;
      // VALID EMAIL SERVICE CALL
      this.usersService.validateEmail(emailAddress).subscribe(response => {
        this.userEmailData.ExistingUser = false;
        if (response.success === false) {
          this.userRecord = response.dataItem;
          if (this.userRecord !== null) {
            this.userEmailData.ExistingUser = true;
            this.existingRecords = true;
            this.newRecord = true;
            this.userRecord.roles = [];
            this.currentRecordId = this.userRecord.id;
          } else {
            this.notificationService.setErrorNotification();
          }
        }
        this.userRecord.roles = this.assignArray(this.userRoles);
      });
    } else {
      this.userEmailData.ExistingUser = false;
      if (!patternMatched) {
        this.invalidEmailFormat = true;
        this.invalidPatternMatch = false;
      } else {
        this.invalidPatternMatch = true;
        this.invalidEmailFormat = false;
      }
    }
  }

  disableRole(addUserEmailForm: any) {
    let isFormValid = (addUserEmailForm.valid && addUserEmailForm.dirty && addUserEmailForm.touched);
    const form = this.userFormData;
    if (isFormValid && form && form.roles && form.roles.length > 0) {
      isFormValid = !form.roles.some(x => x.selected === true);
    }
    return isFormValid;
  }

  onCancel(addUserEmailForm: any): void {
    if (addUserEmailForm.dirty) {
      this.isConfirmOpened = true;
      this.closeUserForm();
    } else {
      this.isConfirmOpened = false;
      this.isAddUserOpened = false;
    }
  }

  onNext() {
    this.currentSection += 1;
    this.userFormData = new NewUserFormData();
    this.userFormData = this.getUpdatedData(this.userFormData);
    this.userFormData.emailAddress = this.userEmailData.NewEmailAddress;
    this.userFormData.isExistingUser = false;
    if (this.userEmailData.CreateUser === 'ExistUser') {
      this.getUserDetailsById(this.userRecord.id);
      this.userFormData.isExistingUser = true;
    }
  }

  disableSave(addUserEmailForm: any) {
    let isFormValid = (addUserEmailForm.valid && addUserEmailForm.dirty);
    const form = this.userFormData;
    if (isFormValid && form && form.roles && form.roles.length > 0) {
      isFormValid = form.roles.some(x => x.selected === true);
    }
    return !isFormValid;
  }

  onPrevious() {
    this.userFormData.id = 0;
    this.currentSection -= 1;
    if (this.currentSection < 1) {
      this.currentSection = 1;
    }
  }

  closeUserForm(): void {
    this.isAddUserOpened = true;
  }

  close(status: any) {
    if (status === 'yes') {
      this.isAddUserOpened = false;
      this.isConfirmOpened = false;
    }
  }

  onSave(userForm: any): void {
    this.subFormData = new NewUserFormData();
    this.isProcessing = true;
    if (userForm.valid) {
        this.constructUserOrg();
        const isNew = this.isAddRecord && ((this.subFormData.id || 0) < 1);
        this.subFormData.isEPUser = true;
        if (isNew) {
          this.subFormData.isActive = true;
        }
        this.usersService.addUpdateUser(this.subFormData, isNew).subscribe( data => {
          if (data && data.success) {
            this.isAddUserOpened = false;
          }
          this.isProcessing = false;
          this.responseMsg.emit(data);
        }, (error: HttpErrorResponse) => {
          console.log(error);
          this.isAddUserOpened = false;
          this.isProcessing = false;
          this.notificationService.setErrorNotification();
        });
    }
  }

  validations(form: any, field: any) {
    const isDirty = (form && form.controls[field] && form.controls[field].dirty);
    if (isDirty) {
      return !form.controls[field].valid;
    }
    return false;
  }

  trimContent(data: any, addUserEmailForm) {
    if (data.target.value) {
      const replaceInput = data.target.value.replace(/[^a-zA-Z]/g, '');
      addUserEmailForm.controls.MiddleName.setValue(replaceInput);
    }
  }

  validRoles(userFormData: any) {
    if (userFormData && userFormData.roles) {
      const roles = userFormData.roles;
      return !(userFormData.roles.filter((x: any) => x.selected).length > 0);
    }
    return true;
  }

  getUpdatedData(userFormData: any): NewUserFormData {
    const roleList = [];
    const detRoles = this.assignArray(this.userRoles.slice(0));
    userFormData.organizations = this.assignArray( userFormData.roles);
    detRoles.forEach(el => {
      const element = el;
      element.selected = userFormData.roles && (userFormData.roles.filter((x: any) => x.roleId === element.id).length > 0);
      roleList.push(element);
    });
    userFormData.roles = roleList.slice(0);
    return userFormData;
  }

  constructUserOrg(): any {
    const roles = this.userFormData.roles.filter(x => x.selected === true);
    const allOrgRoles = [];
    for (const role of roles) {
      const orgs = this.userFormData.organizations;
      const currOrg = orgs.filter(x => x.roleId === role.id);
      if (currOrg && currOrg.length > 0) {
        allOrgRoles.push(currOrg[0]);
      } else {
        const orgRoles = new UserOrgs();
        orgRoles.roleId = role.id;
        orgRoles.userId = this.userFormData.id || 0;
        allOrgRoles.push(orgRoles);
      }
    }
    Object.assign(this.subFormData, this.userFormData);
    this.subFormData.roles = this.assignArray(allOrgRoles);
  }

  assignArray(source: any[]) {
    const dest = [];
    source.forEach((v: any) => {
      const val = (typeof v === 'object') ? Object.assign({}, v) : v;
      dest.push(val);
    });
    return dest;
  }
}
